"use client";

import React, { useEffect, useRef, useState } from "react";
import useCRouter from "@/hooks/useCRouter";
import SearchIcon from "@/assets/icons/search.svg?react";
import CloseIcon from "@/assets/icons/close.svg?react";

export interface IProps {
  open: boolean;
  closeOnBlur?: boolean;
  suggestionRef?: React.RefObject<HTMLDivElement>;
  onClose: () => void;
  onChange?: (text: string) => void;
}

const SearchBar = ({
  open,
  closeOnBlur = false,
  suggestionRef,
  onClose,
  onChange = () => {},
}: IProps) => {
  const router = useCRouter();

  const [searchTerm, setSearchTerm] = useState("");
  const searchBoxRef = useRef<HTMLInputElement>(null);

  function handleChangeSearchTerm(e: React.ChangeEvent<HTMLInputElement>) {
    setSearchTerm(e.target.value);
    onChange(e.target.value);
  }

  function handleSubmit(e: React.FormEvent<HTMLFormElement>) {
    e.preventDefault();
    if (!searchTerm) return;
    router.push(`/search?q=${searchTerm}`);
    onClose();
    setSearchTerm("");
  }

  useEffect(() => {
    setSearchTerm("");
    if (open && searchBoxRef?.current) searchBoxRef?.current?.focus();
  }, [open]);

  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const isClickOutsideSearchBox =
        searchBoxRef.current &&
        searchBoxRef.current?.parentElement &&
        !searchBoxRef.current?.parentElement.contains(event.target as Node);
      const isClickOutsideDropdown =
        suggestionRef?.current && !suggestionRef.current.contains(event.target as Node);

      if (closeOnBlur && isClickOutsideSearchBox && (!suggestionRef || isClickOutsideDropdown)) {
        onClose();
      }
    };

    document.addEventListener("mousedown", handleClickOutside);

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <>
      <form className={`flex h-10 flex-1 items-center bg-tertiary-7 pe-2`} onSubmit={handleSubmit}>
        <input
          ref={searchBoxRef}
          type="text"
          className="me-2 h-full flex-1 border-none bg-transparent text-sm focus:outline-none focus:ring-0 focus-visible:outline-none focus-visible:ring-0"
          placeholder="Search"
          value={searchTerm}
          onChange={handleChangeSearchTerm}
        />
        <button type="submit">
          <SearchIcon color="black" className="opacity-80" />
        </button>
      </form>
      <button type="button" className="ms-2" onClick={onClose}>
        <CloseIcon height={18} width={18} />
      </button>
    </>
  );
};

export default SearchBar;
